import {useRef, useEffect, useState } from "react";
import {Box} from "@mui/material";
import {VariableSizeList as List} from "react-window";
import styles from "../css/Home.module.css";
import {CarCard} from "./CarCard";
import AlertDialogSlide from "./DialogsAlerts";
import {successWorkOrder} from "../serverREST";
import {addListsSearch, removeOrder} from "../redux/listsSlice";
import {useDispatch} from "react-redux";

export function VirtualizedCarCard({data}) {
    const dispatch = useDispatch()
    const [confirmOrder, setConfirmOrder] = useState(null);
    const listRef = useRef(null);
    const sizeMap = useRef({});
    const getSize = index => sizeMap.current[index] || 210;
    const Row = ({index, style}) => {
        const rowRef = useRef(null);
        const resizeTimeoutRef = useRef(null);
        useEffect(() => {
            if (!rowRef.current) return;
            const timeOut = data.length > 100 ? 1 : 90;
            const observer = new ResizeObserver(entries => {
                const height = entries[0].contentRect.height;

                if (sizeMap.current[index] === height) return;

                sizeMap.current[index] = height;

                if (resizeTimeoutRef.current) {
                    clearTimeout(resizeTimeoutRef.current);
                }

                resizeTimeoutRef.current = setTimeout(() => {
                    if (!listRef.current) return;
                    const scrollOffset = listRef.current.state.scrollOffset;
                    const itemOffset = listRef.current._getItemStyle(index)?.top;
                    if (itemOffset >= scrollOffset) {
                        listRef.current.resetAfterIndex(index);
                    }
                }, timeOut);
            });

            observer.observe(rowRef.current);

            return () => {
                observer.disconnect();
                if (resizeTimeoutRef.current) {
                    clearTimeout(resizeTimeoutRef.current);
                }
            };
        }, [index, data]);

        return (
            <div style={style}>
                <div ref={rowRef}
                     style={{
                         paddingBottom: 12,
                     }}
                >
                    <CarCard order={data[index]}  onRequestClose={setConfirmOrder}/>
                </div>
            </div>
        );
    };
    if (data.length < 5) {
        return (
            <Box flexGrow={1} sx={{
                minWidth: "20em",
                overflow: "auto",
                borderRadius: "10px",
                backgroundColor: "#EAEEF3"
            }}>
                {
                    data.map((order, index) => {
                        return <CarCard key={index} order={order}   onRequestClose={setConfirmOrder}/>
                    })
                }
                <AlertDialogSlide
                    open={Boolean(confirmOrder)}
                    title="Закрыть заказ-наряд?"
                    description="После вашего подтверждения заказ-наряд будет сохранён в списке закрытых зака-нарядов."
                    onCancel={() => setConfirmOrder(null)}
                    onConfirm={() => {
                        if (!confirmOrder) return;
                        const updatedOrder = {
                            ...confirmOrder,
                            success: true
                        };
                        dispatch(removeOrder(confirmOrder.workorder_id));
                        successWorkOrder(updatedOrder);
                        dispatch(addListsSearch({
                            status: "success",
                            order: updatedOrder
                        }));
                        setConfirmOrder(null);
                    }}
                />
            </Box>

        )
    }
    return (
        <Box
            className={styles.leftSearchBar}
        >
            <List
                ref={listRef}
                height={window.innerHeight * 0.8}
                width="100%"
                itemCount={data.length}
                itemSize={getSize}
                overscanCount={1}
            >
                {Row}
            </List>
            <AlertDialogSlide
                open={Boolean(confirmOrder)}
                title="Закрыть заказ-наряд?"
                description="После вашего подтверждения заказ-наряд будет сохранён в списке закрытых зака-нарядов. "
                onCancel={() => setConfirmOrder(null)}
                onConfirm={() => {
                    if (!confirmOrder) return;
                    const updatedOrder = {
                        ...confirmOrder,
                        success: true
                    };
                    dispatch(removeOrder(confirmOrder.workorder_id));
                    successWorkOrder(updatedOrder);
                    dispatch(addListsSearch({
                        status: "success",
                        order: updatedOrder
                    }));
                    setConfirmOrder(null);
                }}
            />
        </Box>
    );
}